import React from "react";
import Notifications from "../modules/Notifications/Notifications";

export default function NotificationsPage() {
  return <Notifications />;
}
